export const PageNotFound = () => {
  return (
    <div className="full-page fr-ct-ct bg-secondary">
      <h1 className="txt-primary">404 Page Not Found</h1>
    </div>
  );
};
